import { styled } from '@mui/system'
import { TTheme } from '@/core/theme'
export const OverviewContainer = styled('div')<{ theme?: TTheme }>`
    display: flex;
    justify-content: space-between;
    border: 1px solid ${({ theme }) => theme.colors.semantic.overviewSeparator};
    border-radius: 12px;
`

export const OverviewItemContainer = styled('div')<{ theme?: TTheme }>`
    display: flex;
    width: 100%;
    &:not(:last-child) {
        border-right: 1px solid
            ${({ theme }) => theme.colors.semantic.overviewSeparator};
    }
`
